module.exports = __webpack_public_path__ + "static/img/沙尘暴.2e6ac301.svg";